import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import Pagination from '@cashew/pagination';
import { order } from '@cashew/types';
import cn from 'classnames';
import {
  Box,
  List,
  ListItem,
  PageWithNavigation,
  Title,
  Button,
} from '../../components';
import './index.css';
import OrdersFilter from './OrdersFilter';

const ns = 'abandoned';

/**
 * Orders Page RefundPage
 */
export default () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const history = useHistory();
  const [list, setList] = useState<Array<order.OrderType> | undefined>(
    undefined
  );
  const [records, setRecords] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [isData, setIsData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);

  const isOffline = true;

  return (
    <div className={ns}>
      <Helmet>
        <title>Abandoned</title>
      </Helmet>
      <PageWithNavigation>
        <Title>
          <span>Abandoned orders</span>
          <span>
            <Button
              extraClass="blue show-filter-btn"
              onClick={() => setShowFilter(!showFilter)}
            >
              <div className="btn-with-icon">
                <img src="/fillter.svg" alt="filter" />
                Filters
              </div>
            </Button>
          </span>
        </Title>
        <div className={cn({ 'hide-filter': !showFilter })}>
          <OrdersFilter
            setLoading={setLoading}
            useSelector={useSelector}
            setRecords={setRecords}
            setList={setList}
            pageSize={pageSize}
            pageNumber={pageNumber}
            history={history}
            dispatch={dispatch}
            isListEmpty={!isData}
            setIsData={setIsData}
            isData={isData}
            setPageNumber={setPageNumber}
            records={records}
          />
        </div>
        <div className="space-div" />
        <Box withHeader>
          <>
            <div className={`${ns}__headers`}>
              <p>Order ID</p>
              <p>Order date</p>
              {isOffline && <p>{t('orders.table.merchantOrderCode')}</p>}
              <p>{t('orders.table.storeName')}</p>
              <p>{t('orders.table.status')}</p>
              <p>{t('orders.table.totalAmount')}</p>
            </div>
            <List
              data={list}
              component={ListItem}
              context="abandoned"
              isLoading={loading}
              t={t}
              isOffline={isOffline}
            />
            <Pagination
              records={records}
              pageSize={pageSize}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              changePageSize={setPageSize}
            />
          </>
        </Box>
      </PageWithNavigation>
    </div>
  );
};
